import { MijnRoute } from '../../mijn-navigatie.model';

export const COLLECTION_REMOVE_PERMISSION: MijnRoute = {
    path: 'toestemming-verwijderen',
    navigationEvent: 'toIncassoRemovePermission',
    regex: /^\/incasso\/toestemming-verwijderen$/,
    webcomponent: 'mijn-transacties-incasso-webcomponent',
    internalPath: '/toestemming-verwijderen'
};
